import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Logo = ({ size = 32, dark = false, markOnly = false, className, }) => {
    const fill = dark ? "#ffffff" : "#1d6be5";
    const rule = dark ? "#0c1a2e" : "#ffffff";
    // Proportions are ratios of `size` so the mark stays correct at any scale.
    const ear = Math.round(size * 0.375);
    const body = Math.round(size * 0.875);
    const radius = Math.round(size * 0.3125);
    const ruleH = Math.max(2, Math.round(size * 0.094));
    const pad = Math.round(size * 0.22);
    return (_jsxs("span", { className: className, style: { display: "inline-flex", alignItems: "center", gap: 10 }, children: [_jsxs("span", { "aria-hidden": "true", style: {
                    position: "relative",
                    width: size,
                    height: size,
                    flex: "none",
                }, children: [_jsx("span", { style: {
                            position: "absolute",
                            left: -Math.round(size * 0.094),
                            top: 0,
                            width: ear,
                            height: ear,
                            borderRadius: "50%",
                            background: fill,
                        } }), _jsx("span", { style: {
                            position: "absolute",
                            right: -Math.round(size * 0.094),
                            top: 0,
                            width: ear,
                            height: ear,
                            borderRadius: "50%",
                            background: fill,
                        } }), _jsxs("span", { style: {
                            position: "absolute",
                            left: 0,
                            bottom: 0,
                            width: size,
                            height: body,
                            borderRadius: radius,
                            background: fill,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            gap: Math.round(size * 0.125),
                            padding: `0 ${pad}px`,
                        }, children: [_jsx("span", { style: { height: ruleH, borderRadius: 2, background: rule } }), _jsx("span", { style: {
                                    height: ruleH,
                                    borderRadius: 2,
                                    background: rule,
                                    width: "58%",
                                } })] })] }), markOnly ? null : (_jsxs("span", { style: {
                    // Inline rather than a class: this renders inside the embed badge
                    // on other people's sites, where our stylesheet does not reach.
                    fontFamily: '"M PLUS Rounded 1c", "Plus Jakarta Sans Variable", sans-serif',
                    fontSize: Math.round(size * 0.656),
                    fontWeight: 800,
                    // Looser than the geometric face wanted: rounded terminals
                    // already fill the space between letters.
                    letterSpacing: "-0.02em",
                    lineHeight: 1,
                }, children: [_jsx("span", { style: { color: dark ? "#93b8f7" : "#1d6be5" }, children: "Koa" }), _jsx("span", { style: { color: dark ? "#ffffff" : "#0c1a2e" }, children: "form" })] }))] }));
};
//# sourceMappingURL=Logo.js.map